var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.currentComponent)?_c(_vm.currentComponent,{ref:"editPageComponent",tag:"component"}):_c('el-card',[_c('h1',[_vm._v(_vm._s(_vm.$t('contrato_rastreabilidade.words.module_not_available')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }